import { useCallback } from 'react';
import { Button, Modal, Typography } from 'antd';
import { HotkeyTip } from './hotkey';

export interface UnsavedChangesDialogProps {
  open: boolean;
  /** «Сохранить черновик» для DRAFT, «Сохранить» для перепроведения POSTED. */
  saveLabel: string;
  saving?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

/** §8.7 «Закрытие с несохранёнными изменениями»: Сохранить(-черновик) / Не сохранять / Отмена.
 *  Фокус при открытии — на «Сохранить»: `Esc` в окне привёл сюда, и `Enter` подтверждает самое
 *  безопасное решение (ничего не потерять); «Не сохранять» требует Tab и осознанного нажатия. */
export function UnsavedChangesDialog({ open, saveLabel, saving, onSave, onDiscard, onCancel }: UnsavedChangesDialogProps) {
  // Фокус — кадром позже монтирования: `autoFocus` срабатывает, пока контейнер портала ещё не
  // вставлен в документ, и не действует.
  const focusSave = useCallback((el: HTMLButtonElement | null) => {
    if (el) requestAnimationFrame(() => el.focus());
  }, []);
  return (
    <Modal
      title="Есть несохранённые изменения"
      open={open}
      onCancel={onCancel}
      // Содержимое пересоздаётся при каждом открытии — кнопка получает фокус каждый раз, а antd
      // не перехватывает его на саму панель (он делает это, только если фокус ещё вне диалога).
      destroyOnHidden
      footer={[
        <HotkeyTip key="cancel" label="Отмена" combo="Escape">
          <Button onClick={onCancel}>Отмена</Button>
        </HotkeyTip>,
        <Button key="discard" danger onClick={onDiscard}>
          Не сохранять
        </Button>,
        <Button key="save" ref={focusSave} type="primary" loading={saving} onClick={onSave}>
          {saveLabel}
        </Button>,
      ]}
    >
      <Typography.Text>Закрыть без сохранения?</Typography.Text>
    </Modal>
  );
}
